import { dew as _rangeDew } from "../classes/range";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  const Range = _rangeDew();
  const validRange = (range, options) => {
    try {
      // Return '*' instead of '' so that truthiness works.
      // This will throw if it's invalid anyway
      return new Range(range, options).range || "*";
    } catch (er) {
      return null;
    }
  };
  exports = validRange;
  return exports;
}